<div class="px-5 lg:px-8 xl:px-12 pt-5 pb-9 lg:pb-14">
  <div
    class="grid grid-cols-1 gap-4 md:gap-8 lg:gap-6 xl:gap-8 md:grid-cols-2 mb-4 lg:mb-6 xl:mb-8"
  >
    <app-block-list [blockIdList]="pushes"></app-block-list>
  </div>
</div>
